import { CUSTOM_TEXT_REGEX } from '../lib/constants';
import Logger from '../lib/logger';

class CustomTextInput extends HTMLElement {
  NAME = 'CustomTextInput'
  abortController
  numInputs = 1
  maxInputs

  constructor() {
    super();
    Logger.info(`${this.NAME} > constructor`);
    //
    this.className = 'custom-text-input';
    this.labelWrap = this.querySelector('.custom-text-input__label-wrap');
    this.inputs = this.querySelectorAll('input');
    this.maxInputs = this.inputs.length;
    this.productForm = document.querySelector('product-form form[action="/cart/add"]');
    this.dataset.numLines = this.numInputs;
    //
    this.addLineBtn = document.createElement('BUTTON');
    this.addLineBtn.type = 'button';
    this.addLineBtn.className = 'theme-button theme-button--small custom-text-input__add-btn';
    this.addLineBtn.title = 'add line';
    let span = document.createElement('SPAN');
    span.className = 'theme-button__icon';
    span.dataset.icon = 'plus';
    this.addLineBtn.appendChild(span);
    //
    this.removeLineBtn = document.createElement('BUTTON');
    this.removeLineBtn.type = 'button';
    this.removeLineBtn.className = 'theme-button theme-button--small custom-text-input__remove-btn';
    this.removeLineBtn.title = 'remove line';
    span = document.createElement('SPAN');
    span.className = 'theme-button__icon';
    span.dataset.icon = 'minus';
    this.removeLineBtn.appendChild(span);
    //
    this.labelWrap.append(this.addLineBtn, this.removeLineBtn);
  }

  connectedCallback() {
    Logger.info(`${this.NAME} > connectedCallback`);
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    //
    this.inputs.forEach(input => {
      input.addEventListener('input', () => this.onInput(input), { signal });
    });
    //
    this.addLineBtn.addEventListener('click', () => this.onAddLine(), { signal });
    this.removeLineBtn.addEventListener('click', () => this.onRemoveLine(), { signal });
    //
    if (this.hasAttribute('style')) this.removeAttribute('style');
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.abortController = null;
  }

  static get observedAttributes() {
    return ['data-required'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-required' && newValue !== oldValue) {
      this.inputs[0].required = newValue === 'true';
    }
  }

  onInput(input) {
    // Convert to uppercase and match the regex
    let value = input.value.toUpperCase().match(CUSTOM_TEXT_REGEX)?.join('') || '';
    
    // Truncate manually because some devices don't support maxlength attribute natively
    if (input.dataset.maxLength && input.dataset.maxLength > 0 && value.length > input.dataset.maxLength) {
      console.log('kj truncating', input);
      value = value.substring(0, input.dataset.maxLength);
    }
    
    input.value = value;
  }

  onAddLine() {
    if (this.productForm) {
      this.productForm.parentNode.style.pointerEvents = 'none';
      this.productForm.style.opacity = '0.65';  
    }

    this.numInputs += 1;
    this.dataset.maxInputs = this.numInputs === this.maxInputs;
    this.dataset.numLines = this.numInputs;
    this.inputs[this.numInputs - 1].hidden = false;
    const newMax = parseInt(this.inputs[this.numInputs - 1].dataset.maxLength);
    this.inputs.forEach(input => input.maxLength = newMax);
  }

  onRemoveLine() {
    this.numInputs -= 1;
    this.dataset.maxInputs = this.numInputs === this.maxInputs;
    this.dataset.numLines = this.numInputs;
    this.inputs[this.numInputs].hidden = true;
    this.inputs[this.numInputs].value = null;
    const newMax = parseInt(this.inputs[this.numInputs].dataset.maxLength);
    this.inputs.forEach(input => input.maxLength = newMax);
  }
}

customElements.define('custom-text-input', CustomTextInput);
